module.exports = __webpack_public_path__ + "static/media/Training_oportunity.1e32f5d8.jpg";